import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from 'src/service/billing-management.service';
import { KeyValues10, KeyValues5, LocalService, Status } from 'src/service/local.service';

@Component({
  selector: 'app-no-config-bill-settings',
  templateUrl: './no-config-bill-settings.component.html',
  styleUrl: './no-config-bill-settings.component.scss'
})
export class NoConfigBillSettingsComponent {
  @ViewChild('content_no_config_bill_settings')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  @Input() businessId: string = '';

  htmlId: string = ''; elementIds: any; sideBarBodyHeight: number = 10;

  item: KeyValues10;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private billingManagementService: BillingManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save: 'save_' + this.htmlId
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.billingManagementService.getNoConfigBillingSettings(this.businessId).subscribe(result => {
      this.item = result;
    });
    this.sideBarBodyHeight = window.outerHeight - 150;
  }

  onSave() {
    this.item.key = this.businessId;
    this.billingManagementService.saveNoConfigBillingSettings(this.item).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onCloseTrigger({ data: this.item });
      }
    });
  }
}
